import React from "react";

const CATEGORY_ORDER = [
  "Film/TV/Video",
  "Theatre",
  "Models",
  "Kids/Teens",
  "Representation",
  "Voice-Overs",
  "Background",
  "Student Film",
  "Singers/Musicians",
  "Dance",
  "Promotional",
  "Comedy Clubs",
  "Reality TV",
  "Live Events",
  "Jobs/Internships",
];

export default function CastingCategoriesTabs({
  categories,
  activeFilter,
  setActiveFilter,
}) {
  // sort categories based on desired order
  const sortedCategories = [...categories].sort((a, b) => {
    const indexA = CATEGORY_ORDER.indexOf(a.jobCategoryName);
    const indexB = CATEGORY_ORDER.indexOf(b.jobCategoryName);

    // unknown categories go to the end
    if (indexA === -1) return 1;
    if (indexB === -1) return -1;

    return indexA - indexB;
  });

  return (
    <div className="ds-tabs">
      {/* ALL TAB */}
      <button
        className={`ds-tab ${activeFilter === null ? "active" : ""}`}
        onClick={() => setActiveFilter(null)}
      >
        All
      </button>

      {/* SORTED CATEGORY TABS */}
      {sortedCategories.map((cat) => (
        <button
          key={cat.jobCategoryId}
          className={`ds-tab ${
            activeFilter === cat.jobCategoryName ? "active" : ""
          }`}
          onClick={() => setActiveFilter(cat.jobCategoryName)}
        >
          {cat.jobCategoryName}
        </button>
      ))}
    </div>
  );
}